module.exports = {"510182001":"天彭街道","510182002":"隆丰街道","510182003":"濛阳街道","510182004":"致和街道","510182101":"龙门山镇","510182103":"丽春镇","510182104":"九尺镇","510182106":"通济镇","510182107":"丹景山镇","510182109":"敖平镇","510182111":"桂花镇","510182121":"白鹿镇","510182123":"葛仙山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510182.json
// module id = 2401
// module chunks = 0